/**
 * Pill-style tabs for Match Hub.
 */

import React, { useMemo } from 'react';
import { Pressable, Text, View } from 'react-native';
import { useTheme } from '../../../src/theme/useTheme';
import { getMatchHubTabBarStyles } from './MatchHubTabBar.styles';
import type { MatchHubTabKey } from '../../../src/match/types/matchHub.types';

const TABS: { key: MatchHubTabKey; label: string }[] = [
  { key: 'overview', label: 'Overview' },
  { key: 'lineups', label: 'Lineups' },
  { key: 'table', label: 'Table' },
  { key: 'h2h', label: 'H2H' },
];

export interface MatchHubTabBarProps {
  active: MatchHubTabKey;
  onChange: (key: MatchHubTabKey) => void;
  hiddenTabs?: readonly MatchHubTabKey[];
}

export const MatchHubTabBar: React.FC<MatchHubTabBarProps> = ({ active, onChange, hiddenTabs }) => {
  const theme = useTheme();
  const styles = useMemo(() => getMatchHubTabBarStyles(theme), [theme]);
  const visibleTabs = hiddenTabs?.length ? TABS.filter((t) => !hiddenTabs.includes(t.key)) : TABS;

  return (
    <View style={styles.bar} testID="match-hub-tab-bar" accessibilityRole="tablist">
      {visibleTabs.map((tab) => {
        const isActive = tab.key === active;
        return (
          <Pressable
            key={tab.key}
            onPress={() => {
              onChange(tab.key);
            }}
            style={[styles.tab, isActive && styles.tabActive]}
            accessibilityRole="tab"
            accessibilityState={{ selected: isActive }}
            testID={`match-hub-tab-${tab.key}`}
          >
            <Text style={[styles.label, isActive && styles.labelActive]}>{tab.label}</Text>
          </Pressable>
        );
      })}
    </View>
  );
};
